import growth from '../img/GrowthMindset.png';
import passion from '../img/InspiringPassion.png';
import tenacious from '../img/TenaciousProblemSolvers.png';
import nibfam from '../img/Nibfam.png';

let values = [
    {
        title: "Impact Across Many Domains",
        description: "Our contributions to a more socially and environmentally sustainable world take many forms and come from diverse places. We pursue synergies and multi-disciplinary thinking to drive change for the broadest impact.",
        image: passion,
        alt: "Icon",
    },
    {
        title: "Growth Mindset",
        description: "We actively search for ways to develop and improve ourselves, those around us, our organization, and society at large. Feedback and learning are critical processes that continuously shape what we can do and who we are.",
        image: growth,
        alt: "Growth Mindset Icon",
    },
    {
        title: "Tenacious Problem Solving",
        description: "In order to deliver outstanding results, we embrace challenges and push through difficult problems with perseverance and ingenuity. Dedication and intelligent effort are how we make a difference in our work.",
        image: tenacious,
        alt: "Tenacious Problem Solvers Icon",
    },
    {
        title: "#NIBFam",
        description: "Beyond consulting, we are a tight-knit social group committed to supporting our members in all endeavors. We take pride and joy in enriching each other’s lives and celebrating every individual as part of the Net Impact Berkeley family.",
        image: nibfam,
        alt: "NIBFam Icon",
    },
];

export default values;
